import { Button } from '$partials/ui';
import React from 'react';
import { SimpleImage } from '$partials/media';
import { formatLinkBlockToUrl } from '$utilities/data';
import IconArrow from '$partials/icons/icon-arrow';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ImageCardStacked}
 */

const ImageCardStacked = ({
    heading,
    imageCards
}) => {

    return (
        <div className='module-image-card-stacked theme-light bg-main-background py-24 sm:py-40 md:py-32'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='col-wrapper'>
                    {/* Heading Section */}
                    {heading && (
                        <div className='mb-24 col-padding'>
                            <h2 className='type-style-2'>
                                {heading}
                            </h2>
                        </div>
                    )}
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-y-24'>
                        {imageCards?.map((card, index) => {
                            const linkUrl = formatLinkBlockToUrl(card.optionalLink);
                            const content = (
                                <>
                                    {card?.heading && (
                                        <h3 className='type-style-3 text-main-text-primary'>
                                            {card.heading}
                                        </h3>
                                    )}

                                    {card?.image && (
                                        <figure className='relative group hidden md:block'>
                                            <SimpleImage
                                                {...card.image.image}/>
                                            {linkUrl && (
                                                <div className='absolute inset-0 opacity-0 group-hover:opacity-100 before:absolute before:inset-0 before:bg-[rgba(0,0,0,0.4)] before:mix-blend-saturation before:content-[""] after:absolute after:inset-0 after:bg-[rgba(30,37,165,0.5)] after:mix-blend-screen after:content-[""]' />
                                            )}
                                        </figure>

                                    )}
                                    <IconArrow className='md:hidden block h-[9px]'/>
                                </>
                            );

                            const className = `flex flex-row justify-between items-center md:items-start md:flex-col gap-16 col-padding ${index % 3 !== 2 ? 'md:border-r md:border-main-border' : ''}`;

                            return (
                                <React.Fragment key={index}>
                                    {linkUrl && (
                                        <Button
                                            as='a'
                                            className={className}
                                            href={linkUrl}
                                            key={card.id || index}>
                                            {content}
                                        </Button>
                                    )}
                                    {!linkUrl && (
                                        <div
                                            className={className}
                                            key={card.id || index}>
                                            {content}
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ImageCardStacked;
